import illustration1 from '../../../img/renaissance-new/plusWorks/1.svg';
import illustration2 from '../../../img/renaissance-new/plusWorks/2.svg';
import illustration3 from '../../../img/renaissance-new/plusWorks/3.svg';
import illustration4 from '../../../img/renaissance-new/plusWorks/4.svg';
import illustration5 from '../../../img/renaissance-new/plusWorks/5.svg';
import illustration6 from '../../../img/renaissance-new/plusWorks/6.svg';

export const WHY_IT_WORKS_CARDS = [
  { title: 'One structured path—from coding fundamentals to Agentic AI', illustration: illustration1 },
  { title: 'Learn with engineers who understand real-world development', illustration: illustration2, illustrationRight: 0 },
  { title: 'Learn it. Build it. Get evaluated on it.', illustration: illustration3, illustrationRight: 0 },
  { title: 'Practice for the technical interviews you want to crack', illustration: illustration4, illustrationRight: 0 },
  {
    title: 'Learn alongside ambitious developers building for the AI era',
    illustration: illustration5,
    cardBackground: 'radial-gradient(ellipse 70% 60% at 50% 65%, #4650C2 0%, #8B94DE 45%, #FFFFFF 85%)',
  },
  { title: 'Learn at your pace. Revisit concepts whenever you need them.', illustration: illustration6 },
];
